import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";
import Auth from "../../passapp-sdk/Auth";
import Global from "../../passapp-sdk/global";
import User from "../../passapp-sdk/user";
import { store } from "../store";
import BundleKey from "../../translation/bundleKey";
import { clearStorage } from "../../utils/Store";
import { resolveSpaceScope } from "../../utils/space";
import { RootState } from "../reducers/rootReducer";
import { IAuthAction } from "./types/authTypes";

const auth = new Auth();
const user = new User();
const global = new Global();

//Actions creators

export const loginRequest = (): IAuthAction<any> => {
  return {
    type: "LOGIN_REQUEST",
  };
};

export const loginSuccess = (authData: any): IAuthAction<any> => {
  return {
    type: "LOGIN_SUCCESS",
    payload: authData,
  };
};

export const loginFailure = (): IAuthAction<any> => {
  return {
    type: "LOGIN_FAILURE",
  };
};

export const changeLang = (lang: string): IAuthAction<any> => {
  return {
    type: "CHANGE_LANG",
    payload: lang,
  };
};

export const tokenImage = (token: string): IAuthAction<any> => {
  return {
    type: "TOKEN_IMAGE",
    payload: token,
  };
};

export const loginError = (error: any): IAuthAction<any> => {
  return {
    type: "LOGIN_ERROR",
    payload: error,
  };
};

export const resetError = (): IAuthAction<any> => {
  return {
    type: "RESET_ERROR",
  };
};

export const logout = (): IAuthAction<any> => {
  clearStorage();
  window.location.replace("/");
  return {
    type: "LOGOUT",
  };
};

export const expireSession = (): IAuthAction<any> => {
  return {
    type: "SESSION_EXPIRE",
  };
};

export const getLots = (lots: any): IAuthAction<any> => {
  return {
    type: "GET_LOTS",
    payload: lots,
  };
};

export const getResidents = (residents: any): IAuthAction<any> => {
  return {
    type: "GET_RESIDENTS",
    payload: residents,
  };
};

export const getEmployees = (employees: any): IAuthAction<any> => {
  return {
    type: "GET_EMPLOYEES",
    payload: employees,
  };
};

export const getProfessionTypes = (professions: any): IAuthAction<any> => {
  return {
    type: "GET_PROFESSION_TYPES",
    payload: professions,
  };
};

export const getVehicleTypes = (vehicleTypes: any): IAuthAction<any> => {
  return {
    type: "GET_VEHICLE_TYPES",
    payload: vehicleTypes,
  };
};

export const getAllowTransport = (allowTransport: boolean): IAuthAction<any> => {
  return {
    type: "GET_ALLOW_TRANSPORT",
    payload: allowTransport,
  };
};

export const getAppTexts = (appTexts: any): IAuthAction<any> => {
  return {
    type: "GET_APP_TEXTS",
    payload: appTexts,
  };
};

export const getCountry = (country: any): IAuthAction<any> => {
  return {
    type: "GET_COUNTRY",
    payload: country,
  };
};

export const getGlobalDeviceOptions = (options: any): IAuthAction<any> => {
  return {
    type: "GET_GLOBAL_DEVICE_OPTIONS",
    payload: options,
  };
};

export const getSpace = (space: any): IAuthAction<any> => {
  return {
    type: "GET_SPACE",
    payload: space,
  };
};

export const login = (email: string, password: string, lang?: string) => (dispatch: Dispatch) => {
  dispatch(loginRequest());
  auth
    .login(email.toLowerCase(), password)
    .then((response: any) => {
      if (response.data.token) {
        dispatch(loginSuccess(response.data));
        getResidentsOfCountry(response.data.token, dispatch);
        getLotsOfCountryAndProfessionType(response.data.token, dispatch, lang);
        refreshTokenImage(response.data.token, dispatch);
      } else {
        dispatch(loginFailure());
      }
    })
    .catch((err) => {
      console.error(`Error: ${err}`);
      dispatch(loginError(BundleKey.LOGIN_ERROR));
    });
};

export const refreshTokenImage = (token: string, dispatch: Dispatch) => {
  user
    .getTokenAccessImage(token)
    .then((responseImage: any) => {
      dispatch(tokenImage(responseImage.data.token));
    })
    .catch((err) => {
      console.error(`Error: ${err}`);
    });
};

export const getLotsOfCountryAndProfessionType = (
  token: string,
  dispatch: Dispatch,
  lang?: string
) => {
  refreshToken(dispatch, store.getState);
  global.getGlobalOptions(token, lang).then((response: any) => {
    dispatch(getLots(response.data.lots));
    dispatch(getProfessionTypes(response.data.professionTypes));
    dispatch(getVehicleTypes(response.data.vehicleTypes));
    dispatch(getAllowTransport(response.data.allowTransport));
    dispatch(getAppTexts(response.data.appTexts));
    dispatch(
      getCountry({
        country: response.data.country,
        countryName: response.data.countryName,
        countryCode: response.data.countryCode,
      })
    );
    dispatch(
      getGlobalDeviceOptions({
        hikvisions: response.data.hikvisions,
        hikvisionsDefault: response.data.hikvisionsDefault,
        retentionTimeIn: response.data.retentionTimeIn,
        retentionTimeOut: response.data.retentionTimeOut,
      })
    );
    // El id del espacio a cargo lo dejó el login; acá se le suma el detalle.
    const auth = store.getState().auth;
    dispatch(getSpace(resolveSpaceScope(auth.space?.id || "", response.data, auth.buildings)));
  });
};

export const getLotsOfCountry = (token: string, dispatch: Dispatch, lang?: string) => {
  global.getGlobalOptions(token, lang).then((response: any) => {
    dispatch(getLots(response.data.lots));
  });
};

export const getResidentsOfCountry = (token: string, dispatch: Dispatch) => {
  if (token) {
    user
      .findResidents(token, "")
      .then((response) => {
        dispatch(getResidents(response.data));
      })
      .catch((err) => {
        console.info(err);
      });
  }
};

export const findAllEmployees = (token: string, dispatch: Dispatch) => {
  if (token) {
    user
      .findEmployees(token, "")
      .then((response) => {
        dispatch(getEmployees(response.data));
      })
      .catch((err) => {
        console.info(err);
      });
  }
};

export function refreshToken(dispatch: any, getState: any) {
  const token = getState().auth.token;
  dispatch({ type: "USER_REQUEST_TOKEN_FILE" });
  /*** lOAD JWT FILE *****/
  user
    .getTokenAccessImage(token)
    .then((response: any) => {
      let tokenFile = response.data;
      let tdata = { token: tokenFile.token, exp: null, wait: false };
      let tokenPart = tokenFile.token.split(".");
      if (tokenPart[1]) {
        const aux = JSON.parse(atob(tokenPart[1]));
        if (aux.exp) tdata.exp = aux.exp;
      }
      dispatch({ type: "USER_TOKEN_FILE", payload: tdata });
    })
    .catch(() => {
      let tdata = { token: "", exp: null, wait: true };
      dispatch({ type: "USER_TOKEN_FILE", payload: tdata });
    });
}

export const refreshActionToken = () => (dispatch: any, getState: any) => {
  refreshToken(dispatch, getState);
};

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
